import _ from 'lodash';

const filterDuplicates = <T>(arr: T[]) => {
    return _.uniqWith(arr, _.isEqual);
};

export default filterDuplicates;
